// Internal Date Parsing Function
function dateParser(dateString) {
  if(typeof dateString === 'string') {
    const dtParts = dateString.split(' ')
    const dateParts = dtParts[0].split('-')
    if(dateParts.length < 3) return false
    if(dtParts.length === 1) return new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]), 12, 0, 0)
    const timeParts = dtParts[1].split(':')
    if(timeParts.length < 3) return false
    return new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]), parseInt(timeParts[0]), parseInt(timeParts[1]), parseInt(timeParts[2]))
  } else {
    return false
  }
}

export function viewDate(idate, locale, short) {
  if(!locale) locale = 'en'
  let date;
  if (typeof idate === 'string') {
    date = dateParser(idate)
  }
  if (typeof idate == 'object' && idate instanceof Date) {
    date = idate
  }

  if (short) {
    return date.toLocaleString(
      locale , {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      })
  }
  return date.toLocaleString(
    locale , {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
}

export function viewTime(idate, locale, timezone) {
  if(!locale) locale = 'en'
  let date;
  if (typeof idate === 'string') {
    date = dateParser('2010-01-01 ' + idate)
  }
  if (typeof idate == 'object' && idate instanceof Date) {
    date = idate
  }

  if(!timezone) timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return date.toLocaleString(
    locale , {
      // timeZone: timezone,
      hour12: true,
      hour: 'numeric',
      minute: 'numeric'
    })
}

export function viewDatetime(idate, locale, timezone) {
  if(!locale) locale = 'en'
  let date = new Date();
  if (typeof idate === 'string') {
    date = dateParser(idate)
  }
  if (typeof idate == 'object' && idate instanceof Date) {
    date = idate
  }
  if(!timezone) timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return date.toLocaleString(locale, {
      // timeZone: timezone,
      hour12: true,
      weekday: 'short',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    })
}
